import { useEffect, useState } from 'react'
import { getExtensionsSubscriptions, getExtensionsSubscriptionsQuota } from './extensions-subscriptions.services'
import { getProductFruitsExtensionSubscriptionData } from './extensions-subscriptions.utils'
import { IProductFruitsExtensions } from './extensions-subscriptions.interfaces'

const useExtensionsSubscriptions = () => {
  const [productFruitsExtensionsSubscriptions, setProductFruitsExtensionsSubscriptions] =
    useState<IProductFruitsExtensions | null>(null)

  useEffect(() => {
    const getExtensionsData = async () => {
      const extensionsSubscriptionsData = await getExtensionsSubscriptions()
      const extensionsSubscriptionsQuotaData = await getExtensionsSubscriptionsQuota()

      if (extensionsSubscriptionsData && extensionsSubscriptionsQuotaData) {
        const productFruiotsextensionsSubscription = getProductFruitsExtensionSubscriptionData(
          extensionsSubscriptionsData,
          extensionsSubscriptionsQuotaData
        )

        setProductFruitsExtensionsSubscriptions(productFruiotsextensionsSubscription)
      }
    }

    getExtensionsData()
  }, [])

  return {
    productFruitsExtensionsSubscriptions
  }
}

export { useExtensionsSubscriptions }
